// extracted by mini-css-extract-plugin
export default {"container":"delete-modal-component_container__wAhfM","truncate-table":"delete-modal-component_truncate-table__6AUfa","table-text-faded":"delete-modal-component_table-text-faded__PDKY8","buttons":"delete-modal-component_buttons__fnr-U","firstButton":"delete-modal-component_firstButton__43d3l","deleteModal":"delete-modal-component_deleteModal__uqRJz","description":"delete-modal-component_description__s5cUn"};
    if(module.hot) {
      // 1793877076854
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  